<template>
  <div class="bg-white h-full">
    <el-dialog
      title="Add Topic"
      :visible.sync="centerDialogVisible"
      width="40%"
      :before-close="handleclosepopup"
      center
    >
      <AddNewTopic :objid="Objids" />
    </el-dialog>
    <div class="topicpopup">
      <el-dialog title="Chapter 1" width="50%" :visible.sync="outerVisible">
        <el-dialog
          width="35%"
          title="Delete"
          :visible.sync="innerVisible"
          class="mt-24"
        >
          <p class="text-center mb-3 font-bold text-2xl">
            Are You Sure You Want To Delete Topic 1?
          </p>
          <div class="flex justify-center items-center">
            <!-- <div class="w-1/3">
              <img src="../../../../../../assets/images/two.png" alt="" class="w-full" />
            </div> -->
          </div>
          <div class="flex gap-5 mt-5">
            <!-- <el-button class="butto-chapter w-full">Delete</el-button> -->
            <vs-button color="primary" class="button2" type="filled"
              >Delete</vs-button
            >

            <!-- <el-button plain class="w-full">Cancel</el-button> -->
            <vs-button color="primary" class="button2" type="border"
              >Cancel</vs-button
            >
          </div>
        </el-dialog>

        <div
          class="topics flex justify-between mt-4"
          v-for="(item, index) in TopicByID"
          :key="index"
        >
          <p class="font-medium">{{ item.name }}</p>
          <div class="flex gap-4">
            <feather-icon
              icon="EyeIcon"
              svgClasses="w-5 h-5"
              class="cursor-pointer"
            />
            <feather-icon
              icon="Edit2Icon"
              svgClasses="w-5 h-5"
              class="cursor-pointer"
              @click="innerVisible2 = true"
            />
            <feather-icon
              icon="Trash2Icon"
              svgClasses="w-5 h-5"
              class="cursor-pointer"
              @click="DeleteTopics(item)"
            />
          </div>
        </div>
      </el-dialog>
    </div>
    <div class="topicpopup">
      {{ chaptername }}
      <el-dialog
        title="Add Chapter"
        :visible.sync="addChapter"
        width="30%"
        :before-close="handleClosepopuchapterp"
      >
        <AddChapterPopup
          :updateObject="updateObject"
          :handleaddchapter="handleaddchapter"
          :handleUpdateChapter="handleUpdateChapter"
        />
      </el-dialog>
    </div>
    <div class="seth-set bg-primary">
      <div class="absolute top-0 py-10 w-full px-6 flex">
        <div>
          <p
            @click="handleBack"
            class="gap-2 cursor-pointer fsize14 mb-1 text-white flex items-center font-medium"
          >
            <feather-icon
              class="flex"
              icon="ArrowLeftIcon"
              svgClasses="w-6 h-6"
            />
            Go Back
          </p>
          <h2 class="text-white pt-1 text-2xl capitalize font-semibold">
            Customize
          </h2>
        </div>
      </div>
    </div>
    <div class="flex justify-end items-end p-8">
      <!-- <el-button plain icon="el-icon-plus" class="rounded" @click="addChapter = true">Add Chapter</el-button> -->
      <vs-button
        color="primary"
        class="button5"
        type="border"
        @click="addChapter = true"
        >Add Chapter</vs-button
      >
    </div>
    <div class="grid grid-cols-4 gap-4 mt-5 px-4 card-container">
      <el-card shadow="always" v-for="item in chapterlist" :key="item._id">
        <p class="font-medium text-lg mb-2">{{ item.name }}</p>
        <div class="flex mb-4">
          <p class="mr-2 mt-2 mb-2">{{ item.topic.length }} Topics</p>
          <p class="ml-2 mt-2 mb-2 check">
            {{ item.createdAt | moment("h") }}hrs
            {{ item.createdAt | moment("mm") }}min
          </p>
        </div>
        <div class="flex justify-between items-center">
          <div class="button-toppic">
            <!-- <el-button size="small" icon="el-icon-plus" plain @click="outerVisible = true">Add Topic</el-button> -->
            <vs-button
              color="primary"
              class="button5"
              type="border"
              @click="Addtopicpopup(item)"
              >Add Topic</vs-button
            >
          </div>
          <div class="action-topic">
            <div class="flex gap-4">
              <feather-icon
                icon="EyeIcon"
                svgClasses="w-5 h-5"
                class="cursor-pointer"
                @click="getTopicBychapterid(item)"
              />
              <feather-icon
                icon="Edit2Icon"
                @click="updatechapter(item)"
                svgClasses="w-5 h-5"
                class="cursor-pointer"
              />
              <feather-icon
                icon="Trash2Icon"
                svgClasses="w-5 h-5"
                class="cursor-pointer"
                @click="deleteChapter(item)"
              />
            </div>
          </div>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
// import AddTopicPopupVue from './AddTopicPopup.vue';
import { mapState } from "vuex";
import moment from "moment";
import AddChapterPopup from "./AddChapterPopup.vue";
import AddNewTopic from "./AddNewTopic.vue";
export default {
  components: {
    // AddTopicPopupVue,
    AddChapterPopup,
    AddNewTopic,
  },
  data() {
    return {
      // dialogVisible: false,
      outerVisible: false,
      innerVisible: false,
      addChapter: false,
      innerVisible2: false,
      centerDialogVisible: false,
      topicDesc: "",
      selectedChapter: "",
      Objids: {
        chapter: null,
        course: null,
      },
      updateObject: {
        chaptername: null,
        update: false,
      },
    };
  },
  computed: {
    ...mapState("elearningchapter", ["chapterlist"]),
    ...mapState("elearningtopic", {
      TopicByID: "TopicByID",
    }),

    imageURL() {
      return "https://nimbus-server-01.s3.ap-south-1.amazonaws.com";
    },
  },
  mounted() {
    console.log(this.chapterlist, "chapterlistchapterlistchapterlist");
  },
  methods: {
    async DeleteTopics(item) {
      // this.innerVisible = true;
      console.log(item);
      let payload = {
        _id: item._id,
        chapter: item.chapter,
      };
      await this.$store.dispatch("elearningtopic/deleteTopic", payload);
      let data = {
        _id: item.chapter,
      };
      this.getTopicBychapterid(data);
    },
    async getTopicBychapterid(item) {
      const payload = {
        _id: item._id,
      };

      const data = await this.$store.dispatch(
        "elearningtopic/GetTopicByTopicId",
        payload
      );
      console.log(this.TopicByID, "TopicByIDTopicByID");
      this.outerVisible = true;
    },
    handleclosepopup() {
      this.centerDialogVisible = false;
      this.updateObject = false;
    },
    Addtopicpopup(item) {
      console.log("true");
      this.Objids.chapter = item._id;
      this.Objids.course = this.$route.params.id;
      console.log(this.Objids, "ObjidsObjids");
      this.centerDialogVisible = true;
    },
    handleClosepopuchapterp() {
      this.addChapter = false;
      this.chaptername = "";
    },
    async deleteChapter(data) {
      let payload = {
        _id: data._id,
        course: data.course[0],
        topicId: data.topic,
      };
      console.log(payload);

      await this.$store.dispatch("elearningchapter/deleteChapter", payload);
      let payload2 = {
        id: data.course[0],
      };
      await this.$store.dispatch(
        "elearningchapter/GetChapterByCourseId",
        payload2
      );
    },
    async handleUpdateChapter(val) {
      // console.log(val);
      let payload = {
        id: this.selectedChapter._id,
        name: val,
      };
      await this.$store.dispatch("elearningchapter/updateChapter", payload);
      let payload2 = {
        id: this.$route.params.id,
      };
      await this.$store.dispatch(
        "elearningchapter/GetChapterByCourseId",
        payload2
      );
      this.addChapter = false;
    },
    async updatechapter(item) {
      this.addChapter = true;
      this.selectedChapter = item;

      this.updateObject.chaptername = item.name;

      this.updateObject.update = true;
      this.chaptername = item.name;
    },
    async GetChapter() {
      try {
        const payload = {};
        let data = await this.$store.dispatch(
          "elearningchapter/GetChapterByCourseId",
          payload
        );
        console.log(this.chapterlist, "chapterlistchapterlistchapterlist");
      } catch (err) {
        console.log(err);
      }
    },
    getmessage(message, icon) {
      this.$swal({
        text: message,
        icon: icon,
        confirmButtonColor: "#CD3197",
        // cancelButtonColor: "#d33",
        confirmButtonText: "OK",
      });
    },
    async handleaddchapter(name) {
      const payload = {
        name: name,
        course: this.$route.params.id,
      };
      let data = await this.$store.dispatch(
        "elearningchapter/CreateChapter",
        payload
      );
      let payload2 = {
        id: this.$route.params.id,
      };
      if (data.code == 200) {
        this.addChapter = false;
        await this.$store.dispatch(
          "elearningchapter/GetChapterByCourseId",
          payload2
        );
        // this.GetChapter();
        this.getmessage("Chapter Added", "success");
      }
    },
  },
};
</script>

<style>
.card-container .el-card__body {
  background-color: #f8f8f8;
}

.check {
  border-left: 1px solid black;
  padding: 0px 0px 0px 12px;
}

.topicpopup .el-dialog__title {
  color: #fff;
}

.el-dialog__title {
  color: #fff;
}

.butto-chapter {
  background-color: #5a5a5a;
  color: #fff;
}
</style>
